import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=c97a8730&scoped=true"
import script from "./Result.ts?vue&type=script&lang=ts&external"
export * from "./Result.ts?vue&type=script&lang=ts&external"
import style0 from "./Result.vue?vue&type=style&index=0&id=c97a8730&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97a8730",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c97a8730')) {
      api.createRecord('c97a8730', component.options)
    } else {
      api.reload('c97a8730', component.options)
    }
    module.hot.accept("./Result.vue?vue&type=template&id=c97a8730&scoped=true", function () {
      api.rerender('c97a8730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/FilesEditor/pages/Result/Result.vue"
export default component.exports